import { apiClientGeral } from '@/plugins/axios'

export default {
  getTags() {
    return apiClientGeral().get('/tags')
  },
  getSpecificTag(id) {
    return apiClientGeral().get(`/tags/${id}`)
  },
  getTagUse(id) {
    return apiClientGeral().get(`/tags/use/${id}`)
  },
  postTag(form) {
    return apiClientGeral().post('/tags', form)
  },
  putTag(id, form) {
    return apiClientGeral().put(`/tags/${id}`, form)
  },
  deleteTag(id) {
    return apiClientGeral().delete(`/tags/${id}`)
  },
}
